import React, { Component } from "react";
//import TableComp from '../../../../components/_utils/table'
import { TableComp } from "sz-react-utils";
import PageHeaderWrapper from "../../../../components/PageHeaderWrapper";
import moment from "moment";
import {
  Button,
  Card,
  Col,
  DatePicker,
  Icon,
  notification,
  Popconfirm,
  Drawer,
  Form,
  Row,
  Tooltip,
  Tabs,
  Select
} from "antd";
import Request, { API_URL, LAPI_URL, MEDIA_URL } from "../../../../request";
import { connect } from "react-redux";
import _ from "lodash";
import styles from "../../country/all/styles.less";
import { getUrlQueryPushWrapper } from "../../../../routes";
import commonStyle from "../../../common.less";
import setting from "../../../../components/_utils/settings";
import { FormUtils as GetAllFormFields } from "sz-react-utils";
import UniversityImportExcel from "../../../../assets/samplesFiles/universityImport.xlsx";

import { Link } from "react-router-dom";

import userRights from "../../../../components/_utils/userRights";
import { RightsWrapper } from "../../../../components/_utils/utils";

const UniversityRestoreView = userRights.checkRights("UniversityRestore.view");
const UniversityRestoreDelete = userRights.checkRights(
  "UniversityRestore.delete"
);
const { Option } = Select
const { RangePicker } = DatePicker;
const { TabPane } = Tabs;
const companyDetails = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')) : null;

class UniversityFactSheet extends Component {
  state = {
    visible: true,
    universityData: {},
  }

  loadApis = async () => {
    let { record } = this.props;
    let response = await Request.getUniversity(record._id);
    this.setState({ universityData: response.doc });
  }

  componentDidMount() {
    this.loadApis();
  }


  onClose = () => {
    this.setState({ visible: false })
    setTimeout(() => {
      this.props.onClose();
    }, 50)
  }


  downloadInvoice = () => {
    const printContents = document.getElementById('table_with_data').innerHTML;

    // Open a new window
    const printWindow = window.open('', '_blank', 'width=800,height=600');

    // Write the contents to the new window
    printWindow.document.open();
    printWindow.document.write(`
      <html>
        <head>
          <title>Fact Sheet Of ${this.props.record.universityName}</title>
          <style>
            /* Add any styles you want for printing */
            body {
              font-family: Arial, sans-serif;
            }
            table {
              width: 100%;
              border-collapse: collapse;
            }
            table, th, td {
              border: 1px solid black;
            }
            th, td {
              padding: 8px;
              text-align: left;
            }
          </style>
        </head>
        <body>
          ${printContents}
        </body>
      </html>
    `);
    printWindow.document.close();

    // Print the new window
    printWindow.print();

    // Optionally close the print window after printing
    printWindow.onafterprint = () => {
      printWindow.close();
    };
  };


  // downloadInvoice = () => {
  //   var printContents = document.getElementById('table_with_data').innerHTML;
  //   var originalContents = document.body.innerHTML;
  //   document.body.innerHTML = printContents;
  //   window.print();
  //   document.body.innerHTML = originalContents;
  //   setTimeout(() => {
  //     this.onClose()
  //   }, 500)
  // }

  render() {
    let { visible, universityData } = this.state;
    let { record } = this.props;
    return (
      <Drawer
        title={
          <div>
            <React.Fragment>
              Fact Sheet of {record.universityName}
            </React.Fragment>
          </div>
        }
        placement="right"
        closable={true}
        onClose={this.onClose}
        width={1000}
        visible={visible}>
        <Card>
          <Tooltip title="Download Invoice">
            <Button
              loading={false}
              shape="circle"
              icon="download"
              onClick={() => { this.downloadInvoice() }}
            />
          </Tooltip>
          <Card id="table_with_data">
            <div>
              {/* University Name */}
              <div style={{ textAlign: 'center' }}><h2 style={{ textDecoration: 'underline', fontWeight: 'bold' }}>{universityData.universityInstitutionName}</h2></div>
              {/* University and Company Logo */}
              <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between', marginTop: 10 }}>
                <img style={{ width: '120px' }} src={universityData && universityData.contactLogo && universityData.contactLogo.length ? `${LAPI_URL}${universityData.contactLogo[0].url}` : null} />
                <img style={{ width: '140px' }} src={companyDetails && companyDetails.companyLogo ? companyDetails.companyLogo : null} />
              </div>
              {/* University Details */}
              <div style={{ width: '100%', textAlign: 'left', marginTop: 30 }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', border: 'none', margin: '0' }}>
                  <tbody>
                    {/* For Website */}
                    <tr>
                      <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                        <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>Website</span></strong></p>
                      </td>
                      <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                        <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>{universityData.universityWebsite}</span></strong></p>
                      </td>
                    </tr>
                    {/* For Application Fees */}
                    <tr>
                      <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: universityData.differentApplicationFee ? 'center' : 'top' }}>
                        <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>Application Fee</span></strong></p>
                      </td>
                      {
                        record.differentApplicationFee ?
                          <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}>
                              <strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>UG:- {universityData.contactApplicationFeeUG}</span></strong>
                            </p>
                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}>
                              <strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>PG:- {universityData.contactApplicationFeePG}</span></strong>
                            </p>
                          </td>
                          :
                          <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}>
                              <strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>{universityData.waiveApplicationFee ? 'Waived Off' : universityData.contactAppilcationFee}</span></strong>
                            </p>
                          </td>
                      }
                    </tr>
                    {/* For Campus */}
                    <tr>
                      <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: universityData && universityData.campus && universityData.campus.length ? 'center' : 'top' }}>
                        <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>Campuses</span></strong></p>
                      </td>
                      {
                        universityData && universityData.campus && universityData.campus.length ?
                          <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}>
                              <strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>{universityData.campus.map(campus => campus.campusName).join(', ')}</span></strong>
                            </p>
                          </td>
                          : null
                      }
                    </tr>
                    {/* Offer Processing Time */}
                    <tr>
                      <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                        <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>Offer Processing Time</span></strong></p>
                      </td>
                      <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top' }}>
                        <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}>
                          <strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>{universityData.enrollmentAdmissionOffer ? universityData.enrollmentAdmissionOffer : null}</span></strong>
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              {/* Courses Details */}
              <div style={{ textAlign: 'center', marginTop: 30 }}><h3 style={{ textDecoration: 'underline', fontWeight: 'bold' }}>Courses Available in {universityData.universityInstitutionName}</h3></div>
              {
                universityData && universityData.course && universityData.course.length ?
                  <div style={{ width: '100%', textAlign: 'left', marginTop: 30 }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', border: 'none', margin: '0' }}>
                      <thead>
                        <tr>
                          <th style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top', textAlign: 'center', background: '#058ED9' }}>
                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'center', fontSize: '19px', fontFamily: "Comic Sans MS", color: '#fff' }}>
                              <strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>Course Name</span></strong>
                            </p>
                          </th>
                          <th style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top', textAlign: 'center', background: '#058ED9' }}>
                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'center', fontSize: '19px', fontFamily: "Comic Sans MS", color: '#fff' }}>
                              <strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>Fee Payable</span></strong>
                            </p>
                          </th>
                          <th style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top', textAlign: 'center', background: '#058ED9' }}>
                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'center', fontSize: '19px', fontFamily: "Comic Sans MS", color: '#fff' }}>
                              <strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>Intakes</span></strong>
                            </p>
                          </th>
                          <th style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top', textAlign: 'center', background: '#058ED9' }}>
                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'center', fontSize: '19px', fontFamily: "Comic Sans MS", color: '#fff' }}>
                              <strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>IELTS Requirements</span></strong>
                            </p>
                          </th>
                          <th style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top', textAlign: 'center', background: '#058ED9' }}>
                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'center', fontSize: '19px', fontFamily: "Comic Sans MS", color: '#fff' }}>
                              <strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>Academic Requirements</span></strong>
                            </p>
                          </th>
                          <th style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top', textAlign: 'center', background: '#058ED9' }}>
                            <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'center', fontSize: '19px', fontFamily: "Comic Sans MS", color: '#fff' }}>
                              <strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>Pathways</span></strong>
                            </p>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          universityData.course.map((course) => (
                            <tr>
                              <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'center' }}>
                                <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black', textAlign: 'center' }}>{course.courseName ? course.courseName : null}</span></strong></p>
                              </td>
                              <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'center' }}>
                                <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black', textAlign: 'center' }}>{course.payable ? course.payable : null}</span></strong></p>
                              </td>
                              <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'center' }}>
                                <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black', textAlign: 'center' }}>{course && course.intakes && course.intakes.length ? course.intakes.map(intake => moment(intake).format('MMM')).join(', ') : null}</span></strong></p>
                              </td>
                              {/* Ielts Requirement in Course */}
                              <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'center' }}>
                                <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black', textAlign: 'center' }}>{
                                  course.ieltsRequirements && course.ieltsRequirements.length ?
                                    <table>
                                      <thead>
                                        <tr>
                                          <th>Exam Type</th>
                                          <th>Overall</th></tr>
                                      </thead>
                                      <tbody>
                                        {course.ieltsRequirements.map((requirement) => (
                                          <tr>
                                            <td>{requirement.ExamType ? requirement.ExamType : null}</td>
                                            <td>{requirement.Overall ? requirement.Overall : null}</td>
                                          </tr>
                                        ))}
                                      </tbody>
                                    </table>

                                    : null
                                }</span></strong></p>
                              </td>
                              {/* Academics Requirement in Course */}
                              <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'center' }}>
                                <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black', textAlign: 'center' }}>{
                                  course && course.qualification && course.qualification.length ?
                                    <table>
                                      {/* <thead>
                                      <tr>
                                        <th>Qualification</th>
                                        <th>Grading System</th>
                                        <th>Score</th>
                                      </tr>
                                    </thead> */}
                                      <tbody>
                                        {course.qualification.map((qualification) => (
                                          <tr>
                                            <td>{qualification.qualification ? qualification.qualification : qualification.qualification}</td>
                                            <td>{qualification.gradingSystem ? qualification.gradingSystem : 'Percentage'}</td>
                                            <td>{qualification.score ? qualification.score : qualification.percentage}</td>
                                          </tr>
                                        ))}
                                      </tbody>
                                    </table>
                                    : null

                                }</span></strong></p>
                              </td>
                              {/* Pathways in Course */}
                              <td style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'center' }}>
                                <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'left', fontSize: '19px', fontFamily: "Comic Sans MS", color: 'blue' }}><strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black', textAlign: 'center' }}>{course && course.pathways && course.pathways.length ? course.pathways.map(pathway => pathway.pathCourse).join(', ') : null}</span></strong></p>
                              </td>
                            </tr>
                          ))
                        }
                      </tbody>
                    </table>
                  </div>
                  : null
              }
              {/* {
                universityData && universityData.course && universityData.course.length ?
                  universityData.course.map((course) => (
                    <div style={{ width: '100%', textAlign: 'left', marginTop: 30 }}>
                      <table style={{ width: '100%', borderCollapse: 'collapse', border: 'none', margin: '0' }}>
                        <thead>
                          <tr>
                            <th style={{ width: '126pt', border: '1pt solid windowtext', padding: '0cm 5.4pt', verticalAlign: 'top', textAlign: 'center', background: '#058ED9' }}>
                              <p style={{ margin: '0cm', marginBottom: '.0001pt', textAlign: 'center', fontSize: '19px', fontFamily: "Comic Sans MS", color: '#fff' }}>
                                <strong><span style={{ fontSize: '13px', fontFamily: "Helvetica Neue", color: 'black' }}>{course.courseName}</span></strong>
                              </p>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td colSpan="1" style={{ padding: '10px', border: '1pt solid windowtext' }}>
                              <table style={{ width: '100%', borderCollapse: 'collapse', border: 'none' }}>
                                <thead>
                                  <tr>
                                    <th style={{ border: '1pt solid windowtext', padding: '0cm 5.4pt', textAlign: 'center' }}>Fee Payable</th>
                                    <th style={{ border: '1pt solid windowtext', padding: '0cm 5.4pt', textAlign: 'center' }}>Intakes</th>
                                    <th style={{ border: '1pt solid windowtext', padding: '0cm 5.4pt', textAlign: 'center' }}>IELTS Requirement</th>
                                    <th style={{ border: '1pt solid windowtext', padding: '0cm 5.4pt', textAlign: 'center' }}>Academic Requirement</th>
                                    <th style={{ border: '1pt solid windowtext', padding: '0cm 5.4pt', textAlign: 'center' }}>Pathways</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td style={{ border: '1pt solid windowtext', padding: '0cm 5.4pt', textAlign: 'center' }}>{course.payable?course.payable:null}</td>
                                    <td style={{ border: '1pt solid windowtext', padding: '0cm 5.4pt', textAlign: 'center' }}>
                                      {
                                        course && course.intakes && course.intakes.length?
                                        course.intakes.map(intake=>moment(intake).format('MMM')).join(', ')
                                        :null
                                      }
                                    </td>
                                    <td style={{ border: '1pt solid windowtext', padding: '0cm 5.4pt', textAlign: 'center' }}>Detail 2</td>
                                    <td style={{ border: '1pt solid windowtext', padding: '0cm 5.4pt', textAlign: 'center' }}>Detail 2</td>
                                    <td style={{ border: '1pt solid windowtext', padding: '0cm 5.4pt', textAlign: 'center' }}>Detail 2</td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  ))

                  : null
              } */}
            </div>
          </Card>
        </Card>

      </Drawer>
    )
  }
}






@Form.create()
class AllUniversities extends Component {
  state = {
    total: 0,
    totalExpired: 0,
    totalUnderReview: 0,
    totalUnpublished: 0,
    totalDirect: 0,
    totalChannelPartner: 0,
    totalTpscInc: 0,
    printLoading: {},
    exportLoading: false,
    restoreLoading: false,
    showDelete: false,
    visible1: false,
    countryArr: [],
    activeKey: "0",
    universitiesArr: [],
    universityId: null,
    showFactSheetDrawer: false,
    faceSheetUniId: null,
    statusCounts: [],
    partnershipCounts: [],
  };


  getTotalByStatus = (status) => {
    const statusObj = this.state.statusCounts.find(item => item._id === status);
    return statusObj ? statusObj.count : 0; // Return the count, or 0 if not found
  };
  getTotalByPartnership = (partnership) => {
    const partnershipObj = this.state.partnershipCounts.find(item => item._id === partnership);
    return partnershipObj ? partnershipObj.count : 0; // Return the count, or 0 if not found
  };


  setUniversityId = (id) => {
    this.setState({ universityId: id }, () => {
      if (!id) {
        this.table.current.reload();
      } else {
        this.table.current.reload();
      }
    });
  }


  apiRequest = (params) => {
    return new Promise(async (resolve) => {
      this.setState({ exportParams: params });
      params.showDelete = this.state.showDelete;
      params.universityStatus = "Active";
      if (this.state.universityId && this.state.universityId !== null) {
        params._id = this.state.universityId;
      }
      let data = await Request.getUniversities({
        ...params,
        regExFilters: [
          "universityInstitutionName",
          "universityCountry",
          "cityName",
          "universityPartnership",
          "universityCategory",
          "enrollmentAdmissionOffer",
          "enrollmentConfirmation",
          "courseVal",
          "updatedByUser.name",
          "createdByUser.name",
        ],
        dateFilter: this.state.time,
      });
      let { statusCounts, partnershipCounts } = data;
      this.setState({
        total: statusCounts && statusCounts[0] ? statusCounts[0].count : 0, totalUnpublished: statusCounts && statusCounts[1] ? statusCounts[1].count : 0, totalUnderReview: statusCounts && statusCounts[2] ? statusCounts[2].count : 0, totalExpired: statusCounts && statusCounts[3] ? statusCounts[3].count : 0,
        totalDirect: partnershipCounts && partnershipCounts[1] ? partnershipCounts[1].count : 0, totalChannelPartner: partnershipCounts && partnershipCounts[0] ? partnershipCounts[0].count : 0, totalTpscInc: partnershipCounts && partnershipCounts[3] ? partnershipCounts[3].count : 0, statusCounts: statusCounts, partnershipCounts: partnershipCounts
      });
      resolve(data);
    });
  };

  apiUnpublishedRequest = (params) => {
    return new Promise(async (resolve) => {
      this.setState({ exportParams: params });
      params.showDelete = this.state.showDelete;
      params.universityStatus = "Block";
      if (this.state.universityId && this.state.universityId !== null) {
        params._id = this.state.universityId;
      }
      let data = await Request.getUniversities({
        ...params,
        regExFilters: [
          "universityInstitutionName",
          "universityCountry",
          "cityName",
          "universityPartnership",
          "universityCategory",
          "enrollmentAdmissionOffer",
          "enrollmentConfirmation",
          "courseVal",
          "updatedByUser.name",
          "createdByUser.name",
        ],
        dateFilter: this.state.time,
      });
      let { statusCounts, partnershipCounts } = data;
      this.setState({ statusCounts: statusCounts, partnershipCounts: partnershipCounts });
      resolve(data);
    });
  };

  apiUnderReviewRequest = (params) => {
    return new Promise(async (resolve) => {
      this.setState({ exportParams: params });
      params.showDelete = this.state.showDelete;
      params.universityStatus = "Draft";
      if (this.state.universityId && this.state.universityId !== null) {
        params._id = this.state.universityId;
      }
      let data = await Request.getUniversities({
        ...params,
        regExFilters: [
          "universityInstitutionName",
          "universityCountry",
          "cityName",
          "universityPartnership",
          "universityCategory",
          "enrollmentAdmissionOffer",
          "enrollmentConfirmation",
          "courseVal",
          "updatedByUser.name",
          "createdByUser.name",
        ],
        dateFilter: this.state.time,
      });
      let { statusCounts, partnershipCounts } = data;
      this.setState({ statusCounts: statusCounts, partnershipCounts: partnershipCounts });
      resolve(data);
    });
  };
  apiExpiredRequest = (params) => {
    return new Promise(async (resolve) => {
      this.setState({ exportParams: params });
      params.showDelete = this.state.showDelete;
      params.universityStatus = "Expired";
      if (this.state.universityId && this.state.universityId !== null) {
        params._id = this.state.universityId;
      }
      let data = await Request.getUniversities({
        ...params,
        regExFilters: [
          "universityInstitutionName",
          "universityCountry",
          "cityName",
          "universityPartnership",
          "universityCategory",
          "enrollmentAdmissionOffer",
          "enrollmentConfirmation",
          "courseVal",
          "updatedByUser.name",
          "createdByUser.name",
        ],
        dateFilter: this.state.time,
      });
      let { statusCounts, partnershipCounts } = data;
      this.setState({ statusCounts: statusCounts, partnershipCounts: partnershipCounts });
      resolve(data);
    });
  };
  apiDirectRequest = (params) => {
    return new Promise(async (resolve) => {
      this.setState({ exportParams: params });
      params.showDelete = this.state.showDelete;
      if (this.state.universityId && this.state.universityId !== null) {
        params._id = this.state.universityId;
      }
      params.universityPartnership = { $nin: ['Channel Partner', 'LCI Group', 'Not Specified', 'TPSC INC-Direct', 'Ten-Direct', ''] };
      let data = await Request.getUniversities({
        ...params,
        regExFilters: [
          "universityInstitutionName",
          "universityCountry",
          "cityName",
          "universityPartnership",
          "universityCategory",
          "enrollmentAdmissionOffer",
          "enrollmentConfirmation",
          "courseVal",
          "updatedByUser.name",
          "createdByUser.name",
        ],
        dateFilter: this.state.time,
      });
      let { statusCounts, partnershipCounts } = data;
      this.setState({ statusCounts: statusCounts, partnershipCounts: partnershipCounts });
      resolve(data);
    });
  };
  apiChannelPartnerRequest = (params) => {
    return new Promise(async (resolve) => {
      this.setState({ exportParams: params });
      params.showDelete = this.state.showDelete;
      if (this.state.universityId && this.state.universityId !== null) {
        params._id = this.state.universityId;
      }
      params.universityPartnership = { $nin: ['Direct', 'LCI Group', 'Not Specified', 'TPSC INC-Direct', 'Ten-Direct', ''] };
      let data = await Request.getUniversities({
        ...params,
        regExFilters: [
          "universityInstitutionName",
          "universityCountry",
          "cityName",
          "universityPartnership",
          "universityCategory",
          "enrollmentAdmissionOffer",
          "enrollmentConfirmation",
          "courseVal",
          "updatedByUser.name",
          "createdByUser.name",
        ],
        dateFilter: this.state.time,
      });
      let { statusCounts, partnershipCounts } = data;
      this.setState({ statusCounts: statusCounts, partnershipCounts: partnershipCounts });
      resolve(data);
    });
  };
  apiTpscIncRequest = (params) => {
    return new Promise(async (resolve) => {
      this.setState({ exportParams: params });
      params.showDelete = this.state.showDelete;
      if (this.state.universityId && this.state.universityId !== null) {
        params._id = this.state.universityId;
      }
      params.universityPartnership = { $nin: ['Channel Partner', 'LCI Group', 'Not Specified', 'Direct', 'Ten-Direct', ''] };
      let data = await Request.getUniversities({
        ...params,
        regExFilters: [
          "universityInstitutionName",
          "universityCountry",
          "cityName",
          "universityPartnership",
          "universityCategory",
          "enrollmentAdmissionOffer",
          "enrollmentConfirmation",
          "courseVal",
          "updatedByUser.name",
          "createdByUser.name",
        ],
        dateFilter: this.state.time,
      });
      let { statusCounts, partnershipCounts } = data;
      this.setState({ statusCounts: statusCounts, partnershipCounts: partnershipCounts });
      resolve(data);
    });
  };

  onLoadMore = (record) => {
    let tt = 0;
    record.course.forEach((val, index) => {
      if (index + 1 > record.smallCourse.length && tt <= 1) {
        record.smallCourse.push(val);
        tt++;
      }
    });
  };

  showUniversityDetails = async (data) => {
    this.setState({
      showFactSheetDrawer: true, faceSheetUniId: {
        _id: data._id,
        universityName: data.universityInstitutionName
      }
    })
  }

  closeFactSheetDrawer = () => {
    this.setState({ showFactSheetDrawer: false, faceSheetUniId: null })
  }

  printUniversityDetails = async (data) => {
    let printLoading = this.state.printLoading;
    printLoading[data.id] = true;
    this.setState({ printLoading: printLoading });
    let resp = await Request.printUniversityDetails(data);
    printLoading[data.id] = false;
    this.setState({ printLoading: printLoading });

    if (resp && resp.pdfName) {
      const pdfUrl = `${MEDIA_URL}storage/${resp.pdfName}`;
      window.open(pdfUrl, "_blank");
    } else {
      notification.error({
        message: "Error",
        description: "Try again",
      });
    }
  };
  exportExcel = async () => {
    const { exportParams } = this.state;

    this.setState({ exportLoading: true });
    let x = await Request.exportUniversitiesToExcel({
      ...exportParams,
      regExFilters: ["universityInstitutionName"],
    });
    this.setState({ exportLoading: false });

    if (!x.error) {
      window.open(x.url);
    }
  };

  chooseRangerPicker = (date, dateString) => {
    this.setState({
      time: {
        key: "time",
        from: date[0],
        to: date[1],
      },
    });
    if (date[0] == undefined) {
      setTimeout(() => {
        this.table.current.reload();
      }, 500);
    }
  };
  onOk = (value) => {
    this.table.current.reload();
  };

  handleSubmit = (e) => {
    const { dispatch, form } = this.props;
    e.preventDefault();

    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        let values = _.clone(valData);
        let x = null;
        x = await Request.addUniversityThroughExcel(
          values.excelFile[0].response
        );
        // x = await Request.addExcelData(values.excelFile[0].response)
        if (!x.error) {
          notification.success({
            message: x.message,
          });

          this.setState({ visible1: false });
          this.table.current.reload();
        } else {
          notification.error({
            message: x.message,
          });
        }
      }
    });
  };

  handleDelete = (val) => {
    Request.deleteUniversity({ id: val })
      .then((x) => {
        if (x.success) {
          notification.success({
            message: x.msg,
            description: x.msg,
          });
        } else {
          notification.error({
            message: "Error",
            description: x.msg,
          });
        }
        this.table.current.reload();
      })
      .catch((err) => {
        notification.error({
          message: "Error",
          description: "Some Error",
        });
      });
  };
  handleRestore = (val) => {
    Request.restoreUniversity({ _id: val })
      .then((x) => {
        if (x.success) {
          notification.success({
            message: x.msg,
            description: x.msg,
          });
        } else {
          notification.error({
            message: "Error",
            description: x.msg,
          });
        }
        this.table.current.reload();
      })
      .catch((err) => {
        notification.error({
          message: "Error",
          description: "Some Error",
        });
      });
  };

  callback = activeKey => {
    this.setState({ activeKey: activeKey.toString() }, () => {
      this.table.current.reload();
    })
  }

  loadAllCountries = () => {
    let params = {
      results: 100,
      sortField: "countryName",
      sortOrder: "ascend",
    };
    Request.getCountries(params)
      .then((resp) => {
        if (resp) {
          let temp = [];
          _.each(resp.data, (vv) => {
            let findObj = null;
            if (vv.fundVisaChecklist && vv.fundVisaChecklist.length) {
              findObj = vv.fundVisaChecklist[0];
            }
            temp.push({
              display: vv.countryName,
              id: vv._id,
              key: vv._id,
            });
          });
          this.setState({ countryArr: temp });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };


  loadUniversities = async () => {
    let params = {
      results: 10000,
      count: 10000
    }
    let { data } = await Request.getUniversities(params);
    data = data.reduce((temp, vv) => {
      temp.push({ _id: vv._id, universityInstitutionName: vv.universityInstitutionName });
      return temp;
    }, []);
    this.setState({ universitiesArr: data });
  }

  constructor(props) {
    super(props);
    this.table = React.createRef();
  }

  componentDidMount() {
    this.loadAllCountries();
    this.loadUniversities();
  }

  render() {
    const { dispatch } = this.props;
    const { printLoading } = this.state;
    const inputTypes = {
      fields: [
        {
          label: "Choose Excel File",
          key: "excelFile",
          type: "file",
          required: true,
        },
      ],
    };

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
        md: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
        md: { span: 12 },
      },
    };
    const {
      form: { getFieldDecorator, getFieldValue },
    } = this.props;
    const columns = [
      {
        title: "University",
        key: "universityInstitutionName",
        dataIndex: "universityInstitutionName",
        width: 200,
        fixed: "left",
        sorter: true,
        searchTextName: "universityInstitutionName",
        filterRegex: true,
        render: (text, record) => {
          return (
            <div>
              <Tooltip title="Click To Edit Details">
                <a
                  style={{ display: "block" }}
                  target={"_blank"}
                  href={`/master/edit-university?id=${record._id}`}
                >
                  {text} - {record.consortiumId ? record.consortiumId.consortiumName : ""}
                </a>
              </Tooltip>
              <small>
                <a href={record.universityWebsite} target={"_blank"}>
                  {record.universityWebsite}
                </a>
              </small>
            </div>
          );
        },
      },
      {
        title: "City [Country]",
        width: 200,
        key: "cityName",
        dataIndex: "cityName",
        searchTextName: 'cityName',
        filterRegex: true,
        render: (text, record) => {
          return (
            <span>
              {record.universityCity} [{record.universityCountry}]
            </span>
          );
        },
      },
      {
        title: "Country",
        width: 200,
        key: "universityCountryId",
        dataIndex: "universityCountryId",
        filters:
          this.state.countryArr &&
          this.state.countryArr.map((x) => ({
            value: x.id,
            text: x.display,
          })),
        render: (text, record) => {
          return <span>{record.universityCountry}</span>;
        },
      },
      {
        title: "Campuses",
        width: 200,
        key: "campusVal",
        render: (text, record) => {
          let moreCamp = 0;
          if (record.campus) {
            moreCamp = record.campus.length - 2;
          }
          return (
            <div>
              <ul className={commonStyle.ul}>
                {record.campus.map((val, l) => {
                  if (l <= 1) {
                    return (
                      <li key={l}>
                        <Icon key={"check"} />
                        {val.campusName}
                      </li>
                    );
                  } else {
                    return <span key={l} />;
                  }
                })}
              </ul>

              {moreCamp > 0 ? (
                <div className={commonStyle.more}>
                  <a
                    href="javascript:void(0)"
                    onClick={() => {
                      dispatch(
                        getUrlQueryPushWrapper("masters.allCampus", {
                          campusUniversityId: record._id,
                        })
                      );
                    }}
                  >
                    {moreCamp} more
                  </a>
                </div>
              ) : null}
            </div>
          );
        },
      },

      {
        title: "Partnership",
        key: "universityPartnership",
        dataIndex: "universityPartnership",
        sorter: true,
        searchTextName: "universityPartnership",
        filterRegex: true,
        width: 150,
      },

      {
        title: "Category",
        key: "universityCategory",
        dataIndex: "universityCategory",
        sorter: true,
        searchTextName: "universityCategory",
        filterRegex: true,
        width: 150,
      },

      {
        title: "Offer Time",
        key: "enrollmentAdmissionOffer",
        dataIndex: "enrollmentAdmissionOffer",
        sorter: true,
        searchTextName: "enrollmentAdmissionOffer",
        filterRegex: true,
        width: 150,
      },
      {
        title: "COE Time",
        key: "enrollmentConfirmation",
        dataIndex: "enrollmentConfirmation",
        sorter: true,
        searchTextName: "enrollmentConfirmation",
        filterRegex: true,
        width: 150,
      },
      {
        title: "Agent Code",
        key: "agentCode",
        dataIndex: "agentCode",
        width: 90,
      },
      {
        title: "Course",
        key: "courseVal",
        width: 300,
        render: (text, record) => {
          let moreCamp = 0;
          let courses = record.course;
          if (record.course) {
            courses = record.course.filter(
              (course, index) => course.deleted !== true
            );
            moreCamp = courses.length - 1;
          }

          return (
            <div>
              <ul className={commonStyle.ul}>
                {courses && courses.map((val, l) => {
                  if (l < 1) {
                    return (
                      <li key={l}>
                        <Icon key={"check"} />
                        {val.courseName}
                      </li>
                    );
                  } else {
                    return <span key={l} />;
                  }
                })}

                {/* {loadMore}*/}
              </ul>
              {moreCamp > 0 ? (
                <div className={commonStyle.more}>
                  <a
                    href={"javascript:void(0)"}
                    onClick={() => {
                      dispatch(
                        getUrlQueryPushWrapper("masters.allCourse", {
                          courseUniversityId: record._id,
                        })
                      );
                    }}
                  >
                    {moreCamp} more
                  </a>
                </div>
              ) : null}
            </div>
          );
        },
      },
      {
        title: "Status",
        key: "universityStatus",
        dataIndex: "universityStatus",
        sorter: true,
        searchTextName: "universityStatus",
        filterRegex: true,
        width: 150,
      },
      {
        title: "Updated By",
        width: 150,
        key: "updatedByUser",
        dataIndex: "updatedByUser",
        searchTextName: "Updated By",
        render: (text, record) => {
          return (
            <div>
              <div className={commonStyle.user}>{text ? text.name : ""} </div>
              <small>
                {text ? moment(text.time).format(setting.masterFormat) : ""}
              </small>
            </div>
          );
        },
      },
      {
        title: "Created By",
        width: 150,
        key: "createdByUser",
        dataIndex: "createdByUser",
        searchTextName: "Created",
        render: (text, record) => {
          return (
            <div>
              <div className={commonStyle.user}>{text ? text.name : ""} </div>
              <small>
                {text ? moment(text.time).format(setting.masterFormat) : ""}
              </small>
            </div>
          );
        },
      },
      {
        title: "Action",
        key: "operation",

        width: 100,
        render: (text, record) => (
          <React.Fragment>
            {this.state.showDelete == false ? (
              <>
                <Tooltip title="Fact Sheet ">
                  <Button
                    loading={printLoading[record.id]}
                    className={styles.btn}
                    shape="circle"
                    onClick={() => {
                      this.printUniversityDetails(record);
                    }}
                    icon="download"
                  />
                </Tooltip>
                <Tooltip title="View Fact Sheet ">
                  <Button
                    loading={printLoading[record.id]}
                    className={styles.btn}
                    shape="circle"
                    onClick={() => {
                      this.showUniversityDetails(record);
                      // this.showUniversityDetails(record);
                      // this.printUniversityDetails(record);
                    }}
                    icon="eye"
                  />
                </Tooltip>
                <RightsWrapper myRight={"University.view"}>
                  <Tooltip title="Delete University">
                    <Popconfirm
                      title="Are you sure to delete University?"
                      onConfirm={() => this.handleDelete(record._id)}
                      okText="Yes"
                      cancelText="No"
                    >
                      <Button
                        shape="circle"
                        className={styles.btn}
                        icon="delete"
                      />
                    </Popconfirm>
                  </Tooltip>
                </RightsWrapper>
              </>
            ) : (
              <>
                <Tooltip title="Restore">
                  <Popconfirm
                    title="Are you sure to restore University?"
                    onConfirm={() => this.handleRestore(record._id)}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Button shape="circle" className={styles.btn}>
                      Restore
                    </Button>
                  </Popconfirm>
                </Tooltip>
              </>
            )}
          </React.Fragment>
        ),
      },
    ];
    return (
      <PageHeaderWrapper title={`All Universities`}>
        {
          this.state.showFactSheetDrawer ?

            <UniversityFactSheet record={this.state.faceSheetUniId} onClose={this.closeFactSheetDrawer} />
            : null
        }
        <Card style={{ marginBottom: 10 }}>
          <Row style={{ display: "flex" }}>
            <Col span={8}>
              <label>FILTER BY LAST UPDATE</label>
              <RangePicker
                showTime={{ format: "HH:mm" }}
                format="YYYY-MM-DD HH:mm"
                placeholder={["Start Time", "End Time"]}
                onChange={this.chooseRangerPicker}
                onOk={this.onOk}
              />
            </Col>
            <Col span={4} style={{ paddingTop: "1rem" }}>
              <Button
                type={"primary"}
                style={{ textAlign: "center" }}
                onClick={() => {
                  this.setState({ visible1: true });
                }}
              >
                Add Excel File
              </Button>
            </Col>
            <Col>
              <div
                style={{
                  textAlign: "right",
                  marginTop: "15px",
                  marginLeft: "15px",
                }}
              >
                {userRights.checkRights("UniversitiesExcelExport.view") ? (
                  <Button
                    type={"default"}
                    loading={this.state.exportLoading}
                    onClick={() => {
                      this.exportExcel();
                    }}
                  >
                    Export Excel
                  </Button>
                ) : null}
              </div>
            </Col>
            {UniversityRestoreView ? (
              <>
                <Col>
                  <div
                    style={{
                      textAlign: "right",
                      marginTop: "15px",
                      marginLeft: "15px",
                    }}
                  >
                    <Button
                      type={"default"}
                      loading={this.state.restoreLoading}
                      onClick={() => {
                        this.setState({ showDelete: false }, () => {
                          this.table.current.reload();
                        });
                      }}
                    >
                      All Items
                    </Button>
                  </div>
                </Col>
                <Col>
                  <div
                    style={{
                      textAlign: "right",
                      marginTop: "15px",
                      marginLeft: "15px",
                    }}
                  >
                    <Button
                      type={"default"}
                      loading={this.state.restoreLoading}
                      onClick={() => {
                        this.setState({ showDelete: true }, () => {
                          this.table.current.reload();
                        });
                      }}
                    >
                      Deleted Items
                    </Button>
                  </div>
                </Col>
              </>
            ) : null}
            <Col>
              <div
                style={{
                  textAlign: "right",
                  marginTop: "15px",
                  marginLeft: "15px",
                }}
              >
                <Link to="/master/add-university">
                  <Button>Add</Button>
                </Link>
              </div>
            </Col>
          </Row>
        </Card>
        <Card style={{ marginBottom: 10 }}>
          <Row >
            <Col span={12}>
              <label>Search By University</label><br />
              <Select
                allowClear={true}
                showSearch
                defaultValue={""}
                placeholder={"Select University"}
                style={{ width: "200px" }}
                optionFilterProp="children" // <-- Enables searching by university name
                filterOption={(input, option) =>
                  option.props.children.toLowerCase().includes(input.toLowerCase())
                }
                onChange={(val) => this.setUniversityId(val)}
              >
                {
                  this.state.universitiesArr.map((university) => (
                    <Option key={university._id} value={university._id}>{university.universityInstitutionName}</Option>
                  ))
                }
              </Select>
            </Col>
          </Row>
        </Card>
        {/* <Card style={{marginBottom:10}}>
          <Row gutter={16}>
                <Col span={12}>
                  <label>Search By University</label>
                  <Select onChange={console.log('checked')}>
                    
                  </Select>
                </Col>
          </Row>
        </Card> */}
        <Card bordered={true}>
          <Tabs activeKey={this.state.activeKey} onChange={this.callback} type="card" destroyInactiveTabPane >
            <TabPane tab={`Published (${this.getTotalByStatus('Active')})`} key={0}>
              {/* <h3>Count:- {this.state.total}</h3> */}
              <TableComp
                ref={this.table}
                columns={columns}
                apiRequest={this.apiRequest}
                extraProps={{ scroll: { x: 1400 } }}
                pagination={{
                  showSizeChanger: true,
                  defaultPageSize: 20,
                  pageSizeOptions: ["10", "20", "50", "100", "1000"],
                }}
              />
            </TabPane>
            <TabPane tab={`Unpublished (${this.getTotalByStatus('Block')})`} key={1}>
              {/* <h3>Count:- {this.state.totalUnpublished}</h3> */}
              <TableComp
                ref={this.table}
                columns={columns}
                apiRequest={this.apiUnpublishedRequest}
                extraProps={{ scroll: { x: 1400 } }}
                pagination={{
                  showSizeChanger: true,
                  defaultPageSize: 20,
                  pageSizeOptions: ["10", "20", "50", "100", "1000"],
                }}
              />
            </TabPane>
            <TabPane tab={`In Progress (${this.getTotalByStatus('Draft')})`} key={2}>
              {/* <h3>Count:- {this.state.totalUnderReview}</h3> */}
              <TableComp
                ref={this.table}
                columns={columns}
                apiRequest={this.apiUnderReviewRequest}
                extraProps={{ scroll: { x: 1400 } }}
                pagination={{
                  showSizeChanger: true,
                  defaultPageSize: 20,
                  pageSizeOptions: ["10", "20", "50", "100", "1000"],
                }}
              />
            </TabPane>
            <TabPane tab={`Expired (${this.getTotalByStatus('Expired')})`} key={3}>
              {/* <h3>Count:- {this.state.totalExpired}</h3> */}
              <TableComp
                ref={this.table}
                columns={columns}
                apiRequest={this.apiExpiredRequest}
                extraProps={{ scroll: { x: 1400 } }}
                pagination={{
                  showSizeChanger: true,
                  defaultPageSize: 20,
                  pageSizeOptions: ["10", "20", "50", "100", "1000"],
                }}
              />
            </TabPane>
            <TabPane tab={`Direct (${this.getTotalByPartnership('Direct')})`} key={4}>
              {/* <h3>Count:- {this.state.totalExpired}</h3> */}
              <TableComp
                ref={this.table}
                columns={columns}
                apiRequest={this.apiDirectRequest}
                extraProps={{ scroll: { x: 1400 } }}
                pagination={{
                  showSizeChanger: true,
                  defaultPageSize: 20,
                  pageSizeOptions: ["10", "20", "50", "100", "1000"],
                }}
              />
            </TabPane>
            <TabPane tab={`Channel Partner (${this.getTotalByPartnership('Channel Partner')})`} key={5}>
              {/* <h3>Count:- {this.state.totalExpired}</h3> */}
              <TableComp
                ref={this.table}
                columns={columns}
                apiRequest={this.apiChannelPartnerRequest}
                extraProps={{ scroll: { x: 1400 } }}
                pagination={{
                  showSizeChanger: true,
                  defaultPageSize: 20,
                  pageSizeOptions: ["10", "20", "50", "100", "1000"],
                }}
              />
            </TabPane>
            <TabPane tab={`TPSC INC-Direct (${this.getTotalByPartnership('TPSC INC-Direct')})`} key={6}>
              {/* <h3>Count:- {this.state.totalExpired}</h3> */}
              <TableComp
                ref={this.table}
                columns={columns}
                apiRequest={this.apiTpscIncRequest}
                extraProps={{ scroll: { x: 1400 } }}
                pagination={{
                  showSizeChanger: true,
                  defaultPageSize: 20,
                  pageSizeOptions: ["10", "20", "50", "100", "1000"],
                }}
              />
            </TabPane>
          </Tabs>
        </Card>
        {/* <Card bordered={true}>
          <TableComp
            ref={this.table}
            columns={columns}
            apiRequest={this.apiRequest}
            extraProps={{ scroll: { x: 1400 } }}
            pagination={{
              showSizeChanger: true,
              defaultPageSize: 20,
              pageSizeOptions: ["10", "20", "50", "100", "1000"],
            }}
          />
        </Card> */}
        {this.state.visible1 && (
          <Drawer
            title=""
            placement="right"
            closable={true}
            onClose={() => {
              this.setState({
                visible1: false,
              });
            }}
            visible={this.state.visible1}
            width={500}
          >
            <div>
              <Card bordered={true}>
                <div>
                  <Form
                    onSubmit={this.handleSubmit}
                    {...formItemLayout}
                    style={{ marginTop: 8 }}
                  >
                    <GetAllFormFields
                      apiurl={LAPI_URL}
                      inputSchema={inputTypes}
                      getFieldDecorator={getFieldDecorator}
                    />

                    <Button
                      type="primary"
                      htmlType="submit"
                      style={{ marginLeft: "10%" }}
                      loading={this.state.loading}
                    >
                      UPLOAD
                    </Button>

                    <a
                      href={UniversityImportExcel}
                      download={"institute-sample.xlsx"}
                    >
                      <Button
                        type="default"
                        style={{ marginLeft: "10%" }}
                        loading={this.state.loading}
                      >
                        DOWNLOAD SAMPLE FILE
                      </Button>
                    </a>
                  </Form>
                </div>
              </Card>
            </div>
          </Drawer>
        )}
      </PageHeaderWrapper>
    );
  }
}

const mapStateToProps = ({ global }) => ({
  categories: global.categories,
});
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AllUniversities);
